module.exports = __webpack_public_path__ + "static/img/chat1.7b6b4913.png";